export default "__VITE_ASSET__Y31lDVcp__"